import { useCallback, useMemo, useRef, useState } from 'react'
import { useGlobalLoader } from 'hooks'


type UseFlowProviderProps = {
  flow: PaymentModule.PaymentFlowName
  creditCardForm?: PaymentModule.CreditCardForm
  shippingForm?: PaymentModule.ShippingForm
  billingForm?: PaymentModule.ShippingForm
  onSubmit: PaymentModule.PaymentFlowOnSubmit
}

// creates value for flow provider
const usePaymentFlowProvider = (props: UseFlowProviderProps): PaymentModule.PaymentFlowContext => {
  const {
    flow,
    creditCardForm,
    shippingForm,
    billingForm,
    onSubmit,
  } = props

  // ref for payment form in PaymentFlowProvider
  const formRef = useRef<HTMLFormElement>(null)

  // it's used to block submit buttons and the form
  const [ isProcessing, setProcessing ] = useState(false)
  const { showLoader, hideLoader } = useGlobalLoader()

  // starts the flow with provided token function
  const submit = useCallback<PaymentModule.PaymentFlowOnSubmit>(async (params) => {
    showLoader()
    setProcessing(true)

    const isRedirected = await onSubmit(params)

    // ATTN we shouldn't update the state after redirect
    if (!isRedirected) {
      setProcessing(false)
    }

    hideLoader()

    return isRedirected
  }, [ onSubmit, showLoader, hideLoader ])

  return useMemo(() => ({
    flow,
    formRef,
    submit,
    //
    creditCardForm,
    shippingForm,
    billingForm,
    //
    isProcessing,
  }), [ flow, billingForm, creditCardForm, isProcessing, shippingForm, submit ])
}


export default usePaymentFlowProvider
